import React, { useEffect } from 'react'
import asyncRoute from '../../helpers/hoc/asyncRoute';
import { Route, Switch } from 'react-router-dom';
import routes from '../../routes';
import { PrivateRoute } from '../../utils/route-auth';
import { PERMISSION } from '../../constants/permission';



const AddFeeSettings = asyncRoute(() => import('./Add'));
const ListFeeSettings = asyncRoute(() => import('./List'));

const FeeSettings = (props) => {
    const { match } = props;
    return (
        <>
            <Switch>
                <Route exact path={`${match.path}`} render={() =>
                    <ListFeeSettings match={match} />
                }
                />
                <PrivateRoute path={`${match.path}/${routes.feeSettings.addFeeSettings}`} component={AddFeeSettings}
                    permissions={[PERMISSION.FEESETTING.FEESETTING.EDIT]}
                    defaultRoute={'FeeSettings'} />

                <PrivateRoute path={`${match.path}/${routes.feeSettings.editFeeSettings}/:id`} component={AddFeeSettings}
                    permissions={[PERMISSION.FEESETTING.FEESETTING.EDIT]}
                    defaultRoute={'FeeSettings'} />

                <PrivateRoute path={`${match.path}/${routes.feeSettings.viewFeeSettings}/:id`} component={AddFeeSettings}
                    permissions={[PERMISSION.FEESETTING.FEESETTING.VIEW]}
                    defaultRoute={'FeeSettings'} />


            </Switch>
        </>

    )
}



export default FeeSettings;
